export default __webpack_public_path__ + "static/media/profile_tip_profile_video.39053372.svg";